import MantineImage from '../../components/mantine/image';
import { TextInput, Button, Container, Paper, Group, Center, Text, Box } from '@mantine/core';
import Logo from '../../assets/images/jb-logo.svg'
import RightImage from '../../assets/images/login-right-bg.svg'
import RightArrow from '../../assets/images/login-arw.svg'
import UserIcon from '../../assets/images/user-ico.svg'
import { useNavigate } from 'react-router-dom';
interface iForm {
  submit: (e: any) => void;
  formData: any;
}

const Form = ({ formData, submit }: iForm) => {

  const navigate = useNavigate();
  return (
    <Container fluid className='overflow-hidden flex h-screen p-0 item-center justify-between bg-[#041E42] w-full'>
      <Group className='relative h-full flex-col max-w-[435px] w-full justify-center'>
        <Paper className='bg-transparent w-full'>
          <Center mb="2rem">
            <MantineImage src={Logo} className="max-w-[130px] w-full" />
          </Center>
          <form onSubmit={submit}>
            <Group mb='lg' className='bg-[#2F7FE2] flex-col rounded-tr-[46px] rounded-br-[46px] p-8 flex-1 w-full item-start'>
              <TextInput
                {...formData.getInputProps('email')}
                label={<span>Email <span style={{ color: 'red' }}>*</span></span>}
                placeholder="Enter Your Email"
                leftSection={<MantineImage src={UserIcon} width={18} className="mx-2" />}

                w={'100%'}
                styles={{
                  label: { color: 'white', marginBottom: '0.5rem', fontSize: '13px', lineHeight: '16px', fontFamily: 'Gantari-Bold' },
                  input: { backgroundColor: 'white', padding: '10px', paddingLeft: 34, height: 46, width: '100%', maxWidth: '370px' },
                }}
                mb="sm"
                className='custom-placeholder'
              />
              <Text
                className="text-white text-sm cursor-pointer"
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => navigate('/')}
              >
                Back to Login
              </Text>
            </Group>
            <Group>
              <Button
                fullWidth
                size="md"
                style={{ backgroundColor: '#FF5C39', color: 'white', borderRadius: '0px 16px 16px 0px', height: 54, fontSize: '1.125rem' }}
                type="submit"
              >
                Send
                <MantineImage src={RightArrow} style={{ marginLeft: '20px', width: '40px' }} />
              </Button>
            </Group>
          </form>
        </Paper>
        <Text className='text-xs text-white absolute bottom-2 left-0 text-center w-full'>
          © 2026 JB360
        </Text>
      </Group>
      <Group className='sm-hidden mr-[20px]'>
        <Box maw={227} mx="auto" className='pt-[100px]'>
          <div className="curve-custom" style={{ backgroundImage: `url(${RightImage})` }} />
        </Box>
      </Group>
    </Container>
  );
};

export default Form;
